module.exports = __webpack_public_path__ + "static/img/19034C_1_2_C_20220310_LC.217a04c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19034C_1_2_C_20220310_LC.png
// module id = 8V3j
// module chunks = 0